import React from 'react';
import { List, ListItemButton, ListItemText, Collapse, ButtonGroup, Button } from '@mui/material';
import { IconButton, Tooltip, Popover, Box } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import MoreIcon from '@mui/icons-material/MoreVertRounded';
import ClearIcon from '@mui/icons-material/DeleteForeverRounded';
import DuplicateIcon from '@mui/icons-material/FilterNoneRounded';
import { randomString } from '../../../../../utilities/randomUtilities';
import TextFieldListItem from './inputs/TextFieldListItem';
import TextElementHeaderLabel from './TextElementHeaderLabel';
import TextColorListItem from './inputs/TextColorListItem';
import TextFontListItem from './inputs/TextFontListItem';
import TextBoldListItem from './inputs/TextBoldListItem';
import TextShadowListItem from './inputs/shadow/TextShadowListItem';
import TextGlowListItem from './inputs/glow/TextGlowListItem';
import TextDriftListItem from './inputs/TextDriftListItem';
import TextSizeListItem from './inputs/TextSizeListItem';
import TextPositionListItem from './inputs/TextPositionListItem';
import TextAnchorListItem from './inputs/TextAnchorListItem';

const styles = theme => ({
    item: {
        background: theme.palette.action.hover,
    },
    collapse: {
        cursor: "default",
        backgroundColor: theme.palette.background.paperDark
    }
});

class TextElementListItem extends React.Component {
    state = {
        menuId: randomString(),
        open: false,
        menuAnchorEl: null
    }

    render() {
        const { classes, advanced, remove, duplicate, index } = this.props;
        const { menuId, open, menuAnchorEl } = this.state;

        return (
            <>
                {advanced ?
                    <>
                        <ListItemButton
                            onClick={() => this.setState({ open: !open })}
                            aria-expanded={open}
                            sx={{ cursor: "pointer" }}
                            className={open ? classes.item : null}
                        >
                            <ListItemText>
                                {/* Render the header with text value */}
                                <TextElementHeaderLabel index={index} />
                            </ListItemText>
                            <Box>
                                <IconButton
                                    size='small'
                                    aria-controls={menuId}
                                    aria-haspopup='true'
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        this.setState({ menuAnchorEl: event.currentTarget });
                                    }}
                                >
                                    <MoreIcon />
                                </IconButton>
                            </Box>
                        </ListItemButton>
                        <Popover
                            anchorEl={menuAnchorEl}
                            id={menuId}
                            keepMounted
                            open={Boolean(menuAnchorEl)}
                            onClose={() => this.setState({ menuAnchorEl: null })}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'center',
                            }}
                            style={{ lineHeight: 0 }}
                        >
                            <ButtonGroup
                                size='small'
                                aria-label='Text element action button group'
                                variant='text'
                            >
                                <Tooltip
                                    title={duplicate ? 'Duplicate' : ''}
                                    placement='top'
                                    arrow
                                >
                                    <Button
                                        onClick={this.handleDuplicate}
                                        disabled={!Boolean(duplicate)}
                                        aria-label='Duplicate'
                                    >
                                        <DuplicateIcon />
                                    </Button>
                                </Tooltip>
                                <Tooltip
                                    title={remove ? 'Remove' : ''}
                                    placement='top'
                                    arrow
                                >
                                    <Button
                                        onClick={this.handleRemove}
                                        disabled={!Boolean(remove)}
                                        aria-label='Remove'
                                    >
                                        <ClearIcon />
                                    </Button>
                                </Tooltip>
                            </ButtonGroup>
                        </Popover>
                        <Collapse
                            in={open}
                            timeout='auto'
                            unmountOnExit
                            className={classes.collapse}
                        >
                            <List
                                dense
                                disablePadding
                            >
                                {/* Render a main text input */}
                                <TextFieldListItem index={index} />

                                {/* Render a control for the text color */}
                                <TextColorListItem index={index} />

                                {/* Render a control for the text font */}
                                <TextFontListItem index={index} />

                                {/* Render a control for the bold text style */}
                                <TextBoldListItem index={index} />

                                {/* Render a control for the text size */}
                                <TextSizeListItem index={index} />

                                {/* Render a control for the text position */}
                                <TextPositionListItem index={index} />

                                {/* Render a control for the anchor point */}
                                <TextAnchorListItem index={index} />

                                {/* Render a control for the text glow */}
                                <TextGlowListItem index={index} />

                                {/* Render a control for the text shadow */}
                                <TextShadowListItem index={index} />

                                <TextDriftListItem index={index} />
                            </List>
                        </Collapse>
                    </>
                    :
                    // Render the main text input
                    <TextFieldListItem index={index} />
                }
            </>
        );
    }

    handleDuplicate = () => {
        const { duplicate } = this.props;
        duplicate();
        this.setState({ menuAnchorEl: null });
    }

    handleRemove = () => {
        const { remove } = this.props;
        remove();
        this.setState({ menuAnchorEl: null });
    }
}

export default withStyles(TextElementListItem, styles);